/* HOOD WE · product card colour dots: click shows that colour's photo + links to that variant */
(function(){
  if (window.hwSwatch) return; window.hwSwatch = 1;
  var css = '.hw-card__swatches i[data-img],.hw-card__swatches i[data-href]{cursor:pointer;transition:transform .15s ease}.hw-card__swatches i[data-img]:hover,.hw-card__swatches i[data-href]:hover{transform:scale(1.12)}.hw-card__swatches i.is-active{box-shadow:0 0 0 2px var(--card-bg,#f5f5f5),0 0 0 3px #121212}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var SEL = '.hw-card__swatches i[data-img],.hw-card__swatches i[data-href]';
  function pick(d){
    var c = d.closest('.hw-card'); if (!c) return;
    var img = c.querySelector('.hw-card__main');
    if (img && d.dataset.img) { img.removeAttribute('srcset'); img.src = d.dataset.img; }
    if (d.dataset.href) c.setAttribute('href', d.dataset.href);
    c.querySelectorAll('.hw-card__swatches i').forEach(function(x){ x.classList.toggle('is-active', x === d); });
  }
  document.addEventListener('click', function(e){
    var d = e.target.closest && e.target.closest(SEL); if (!d) return;
    e.preventDefault(); e.stopPropagation(); pick(d);
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var d = e.target.closest && e.target.closest(SEL); if (!d) return;
    e.preventDefault(); pick(d);
  }, true);
})();
